import { computed, ComputedRef, onMounted, Ref, useRoute } from '@nuxtjs/composition-api';
import { getCategory } from '@shared/helpers/category/getCategory';
import { Collection, useCategory } from '@unified-commerce/gpc-vue-storefront-shopify';

export interface UseShopifyCategoriesProps {
  id: string;
}

export interface UseShopifyCategoriesReturnProps {
  fetchShopifyCategories: (params?: Record<string, string>) => Promise<void>;
  currentCategory: ComputedRef<Collection | undefined>;
  shopifyCategories: Ref<Collection[]>;
  loading: Ref<boolean>;
  error: Error | null;
}

const useShopifyCategories = (
  { id }: UseShopifyCategoriesProps = { id: 'shopify-category' },
): UseShopifyCategoriesReturnProps => {
  const route = useRoute();
  const { search, categories: shopifyCategories, loading, error } = useCategory(id);

  const fetchShopifyCategories = async (params: Record<string, string> = {}) => {
    if (shopifyCategories.value?.length || loading.value) return;
    await search(params);
  };

  const currentCategory = computed(() => getCategory(route, shopifyCategories.value));

  onMounted(async () => {
    await fetchShopifyCategories();
  });

  return {
    fetchShopifyCategories,
    currentCategory,
    shopifyCategories: computed(() => [...shopifyCategories.value]),
    loading,
    error: error.value.search,
  };
};

export default useShopifyCategories;
